export default "__VITE_ASSET__jQtCyh7___$_?component__"